<section class="tw-p-4">
  <!-- Hamburger menu for mobile (workforce context only) -->
  <button
    *ngIf="wfParent && (isSmallScreen$ | async)"
    class="toggle-sidenav-btn tw-bg-gray-800 tw-p-2 tw-rounded tw-text-white hover:tw-bg-gray-700 @mdx:tw-hidden tw-mb-4 tw-h-10"
    (click)="toggleThinSidenav()"
    aria-label="Open menu">
    <svg
      class="tw-w-6 tw-h-6"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  </button>
  <div class=" tw-max-w-screen-md tw-text-center tw-mb-8 lg:tw-mb-12 tw-mx-auto">
    <h2
      class="tw-mb-4 tw-text-4xl tw-tracking-tight tw-font-bold tw-text-gray-800 dark:tw-text-white">
      <span
        class="tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-to-purple-600 tw-from-sky-500 tw-font-extrabold">
        Unlock The Power
      </span>
      Of Millions Of Job Changes
    </h2>
    <p
      class="tw-mb-5 tw-font-light tw-text-gray-500 dark:tw-text-gray-300 tw-text-base lg:tw-text-lg">
      Our platform monitors millions of job changes monthly at the individual-level. Get the data
      and insights you need, how you need them.
    </p>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-6">
    <app-billing-products-chat></app-billing-products-chat>

    <div class="tw-flex tw-justify-center">
      <app-billing-products-people></app-billing-products-people>
    </div>
  </div>
</section>
